var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKaproScmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    zoomAndPan: "magnify",
    viewBox: "110 125 155 85",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac31e08488)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#684b660fcf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f7e53084a5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b477520a31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36a9e1",
    d: "M 235.554688 139.730469 C 254.453125 139.699219 264.425781 162.363281 251.382812 176.082031 C 251.226562 176.246094 251.070312 176.40625 250.910156 176.566406 L 229.289062 198.1875 C 223.644531 203.832031 214.015625 199.859375 214.027344 191.886719 C 214.042969 182.113281 217.9375 172.734375 224.863281 165.8125 L 196.570312 165.855469 L 170.511719 165.898438 C 170.535156 151.5 182.226562 139.8125 196.613281 139.792969 Z M 235.554688 139.730469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#153d693edc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#61b25ea599)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#08fee778de)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#420b9b7967)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2ad856",
    d: "M 139.148438 192.042969 C 120.25 192.074219 110.277344 169.410156 123.320312 155.691406 C 123.476562 155.527344 123.632812 155.367188 123.789062 155.210938 L 145.414062 133.585938 C 151.058594 127.941406 160.683594 131.917969 160.671875 139.882812 C 160.660156 149.65625 156.761719 159.039062 149.835938 165.960938 L 178.128906 165.917969 L 204.1875 165.871094 C 204.167969 180.265625 192.472656 191.953125 178.085938 191.972656 Z M 139.148438 192.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaproScmIcon);
export default __webpack_public_path__ + "static/media/KaproSCMIcon.ad0dfd99ca5b9a5bff386e936263942d.svg";
export { ForwardRef as ReactComponent };